export const fields = [
  { key: "tag", title: "tags_columns_tag", required: true },
  {
    key: "color",
    title: "tags_columns_color",
    component: "colorinput",
    required: true
  }
];
